import { useState, useEffect } from "react";
import { useCommunication } from "./CommunicationWrapper";
import { tableNameMap } from "./types";

export const useCachedData = (key: string) => {
    const { useRerenderListener, getOptions, sendMessageAndListen } = useCommunication();

    // Watch for changes to the specific cached data key
    const { options: localOptions, trigger } = useRerenderListener([key], "local");

    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<any>(null);

    useEffect(() => {
        // Initial sync and load
        const init = async () => {
            try {
                setLoading(true);
                // Request extension to sync from server if needed
                await sendMessageAndListen({
                    type: "CALL_EXTENSION_FUNC",
                    payload: {
                        func: "syncCachedDataFromServer",
                        args: { key },
                    },
                });

                // Get cached data from local storage
                const local = getOptions("local");
                const cachedData = local[key] ?? null;
                setData(cachedData);
            } catch (err) {
                console.error("Error loading cached data:", err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        init();
    }, [key]);

    // Update data when storage changes
    useEffect(() => {
        const local = getOptions("local");
        setData(local[key] ?? null);
    }, [trigger, key]);

    return { data, loading, error };
}